module.exports = __webpack_public_path__ + "static/img/04-ljmorebg1.74d60251.png";